import { Flex } from '@aloft/toolkit-sui';

import { useWatch } from 'react-hook-form';

import { DepreciationQuestion } from './DepreciationQuestion.tsx';
import { DepreciationToggle } from './DepreciationToggle.tsx';
import { JointDefaultEcoLifeInput } from './JointDefaultEcoLifeInput.tsx';
import { SeparateDefaultEcoLifeTable } from './SeparateDefaultEcoLifeTable.tsx';

export const Depreciation = () => {
  const depreciateSeparately = useWatch({ name: 'depreciateSeparately' });

  return (
    <Flex flexDirection="column" gap="2rem">
      <DepreciationToggle
        question="How would you like to calculate physical depreciation?"
        trueLabel="Depreciate the dwelling and all improvements separately."
        falseLabel="Depreciate the dwelling and all improvements jointly."
        fieldName="depreciateSeparately"
      />
      <DepreciationQuestion question="What is the default economic life of the improvements?">
        {depreciateSeparately === 'true' ? (
          <SeparateDefaultEcoLifeTable />
        ) : (
          <JointDefaultEcoLifeInput />
        )}
      </DepreciationQuestion>
      <DepreciationToggle
        question="Would you like to input functional obsolescence?"
        trueLabel="Yes"
        falseLabel="No"
        fieldName="enableFunctionalDepreciation"
        forceHorizontal
        trueFirst
      />
      <DepreciationToggle
        question="Would you like to input external obsolescence?"
        trueLabel="Yes"
        falseLabel="No"
        fieldName="enableExternalDepreciation"
        forceHorizontal
        trueFirst
      />
    </Flex>
  );
};
